<template>
  <div class="tab-page pods-page">
    <div class="type-wrapper">
      <span
        class="pr-20"
        :class="{ active: type === 'chart_data' }"
        @click="selectType('chart_data')"
        v-if="
          p('Pods.Capacitance Readings Chart.View') ||
            p('Pods.Connection Status Chart.View') ||
            p('Pods.Battery Levels Chart.View') ||
            p('Pods.Accelerometer Readings Chart.View') ||
            p('Pods.SPO2 Chart.View')
        "
      >
        {{ $t('text.chart_data').toLowerCase() }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'calibration' }"
        @click="selectType('calibration')"
        v-if="p('Pods.Calibration.View')"
      >
        {{ $t('text.calibration').toLowerCase() }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'find_data' }"
        @click="selectType('find_data')"
        v-if="p('Pods.Find Data.View')"
      >
        {{ $t('text.find_data').toLowerCase() }}
      </span>
      <span
        :class="{ active: type === 'diagnostics' }"
        @click="selectType('diagnostics')"
        v-if="p('Pods.Diagnostics.View')"
      >
        diagnostics
      </span>
    </div>
    <ChartData v-if="type === 'chart_data'" />
    <Calibration v-if="type === 'calibration'" />
    <FindData v-if="type === 'find_data'" />
    <Diagnostics v-if="type === 'diagnostics'" />
  </div>
</template>

<script>
import ChartData from '@/components/pods/ChartData'
import Calibration from '@/components/pods/Calibration'
import FindData from '@/components/pods/FindData'
import Diagnostics from '@/components/pods/Diagnostics'
export default {
  data() {
    return {
      type: 'chart_data'
    }
  },
  components: {
    ChartData,
    Calibration,
    FindData,
    Diagnostics
  },
  mounted() {
    this.type =
      this.$permission('Pods.Capacitance Readings Chart.View') ||
      this.$permission('Pods.Connection Status Chart.View') ||
      this.$permission('Pods.Battery Levels Chart.View') ||
      this.$permission('Pods.Accelerometer Readings Chart.View') ||
      this.$permission('Pods.SPO2 Chart.View')
        ? 'chart_data'
        : this.$permission('Pods.Calibration.View')
        ? 'calibration'
        : this.$permission('Pods.Find Data.View')
        ? 'find_data'
        : 'diagnostics'
  },
  methods: {
    selectType(type) {
      this.type = type
    }
  }
}
</script>
